var map = {
	"./casino-bg.embed.svg": 60875,
	"./casino-cs.embed.svg": 60978,
	"./casino-da.embed.svg": 38829,
	"./casino-de.embed.svg": 42577,
	"./casino-el.embed.svg": 55355,
	"./casino-en.embed.svg": 58989,
	"./casino-es.embed.svg": 82724,
	"./casino-et.embed.svg": 58343,
	"./casino-fi.embed.svg": 17701,
	"./casino-fr.embed.svg": 53694,
	"./casino-hr.embed.svg": 19730,
	"./casino-hu.embed.svg": 25574,
	"./casino-is.embed.svg": 55119,
	"./casino-it.embed.svg": 85510,
	"./casino-ja.embed.svg": 51066,
	"./casino-lt.embed.svg": 3007,
	"./casino-lv.embed.svg": 47794,
	"./casino-nl.embed.svg": 13403,
	"./casino-no.embed.svg": 27898,
	"./casino-pl.embed.svg": 97271,
	"./casino-pt-BR.embed.svg": 50516,
	"./casino-pt.embed.svg": 95850,
	"./casino-ro.embed.svg": 27797,
	"./casino-ru.embed.svg": 32575,
	"./casino-sl.embed.svg": 62515,
	"./casino-sv.embed.svg": 77863,
	"./casino-uk.embed.svg": 74036,
	"./casino-zh-CN.embed.svg": 24167,
	"./casino-zh-TW.embed.svg": 50745,
	"./poker-bg.embed.svg": 77638,
	"./poker-cs.embed.svg": 8824,
	"./poker-da.embed.svg": 80792,
	"./poker-de.embed.svg": 57160,
	"./poker-el.embed.svg": 57965,
	"./poker-en.embed.svg": 36947,
	"./poker-es.embed.svg": 75988,
	"./poker-et.embed.svg": 3409,
	"./poker-fi.embed.svg": 11405,
	"./poker-fr.embed.svg": 22460,
	"./poker-hr.embed.svg": 28839,
	"./poker-hu.embed.svg": 67364,
	"./poker-is.embed.svg": 16998,
	"./poker-it.embed.svg": 91082,
	"./poker-ja.embed.svg": 38999,
	"./poker-lt.embed.svg": 56466,
	"./poker-lv.embed.svg": 88759,
	"./poker-nl.embed.svg": 41566,
	"./poker-no.embed.svg": 71715,
	"./poker-pl.embed.svg": 88705,
	"./poker-pt-BR.embed.svg": 49538,
	"./poker-pt.embed.svg": 76909,
	"./poker-ro.embed.svg": 65425,
	"./poker-ru.embed.svg": 90282,
	"./poker-sl.embed.svg": 64826,
	"./poker-sv.embed.svg": 94919,
	"./poker-uk.embed.svg": 6517,
	"./poker-zh-CN.embed.svg": 43669,
	"./poker-zh-TW.embed.svg": 15207,
	"./sports-bg.embed.svg": 16580,
	"./sports-cs.embed.svg": 97895,
	"./sports-da.embed.svg": 10230,
	"./sports-de.embed.svg": 19032,
	"./sports-el.embed.svg": 64917,
	"./sports-en.embed.svg": 67664,
	"./sports-es.embed.svg": 76127,
	"./sports-et.embed.svg": 43003,
	"./sports-fi.embed.svg": 1782,
	"./sports-fr.embed.svg": 12572,
	"./sports-hr.embed.svg": 13800,
	"./sports-hu.embed.svg": 17638,
	"./sports-is.embed.svg": 4249,
	"./sports-it.embed.svg": 72434,
	"./sports-ja.embed.svg": 74171,
	"./sports-lt.embed.svg": 33416,
	"./sports-lv.embed.svg": 6311,
	"./sports-nl.embed.svg": 38168,
	"./sports-no.embed.svg": 54397,
	"./sports-pl.embed.svg": 50329,
	"./sports-pt-BR.embed.svg": 1260,
	"./sports-pt.embed.svg": 11529,
	"./sports-ro.embed.svg": 19483,
	"./sports-ru.embed.svg": 24339,
	"./sports-sl.embed.svg": 5419,
	"./sports-sv.embed.svg": 89479,
	"./sports-uk.embed.svg": 11765,
	"./sports-zh-CN.embed.svg": 18583,
	"./sports-zh-TW.embed.svg": 97901,
	"swf-core/assets/localized/casino-bg.embed.svg": 60875,
	"swf-core/assets/localized/casino-cs.embed.svg": 60978,
	"swf-core/assets/localized/casino-da.embed.svg": 38829,
	"swf-core/assets/localized/casino-de.embed.svg": 42577,
	"swf-core/assets/localized/casino-el.embed.svg": 55355,
	"swf-core/assets/localized/casino-en.embed.svg": 58989,
	"swf-core/assets/localized/casino-es.embed.svg": 82724,
	"swf-core/assets/localized/casino-et.embed.svg": 58343,
	"swf-core/assets/localized/casino-fi.embed.svg": 17701,
	"swf-core/assets/localized/casino-fr.embed.svg": 53694,
	"swf-core/assets/localized/casino-hr.embed.svg": 19730,
	"swf-core/assets/localized/casino-hu.embed.svg": 25574,
	"swf-core/assets/localized/casino-is.embed.svg": 55119,
	"swf-core/assets/localized/casino-it.embed.svg": 85510,
	"swf-core/assets/localized/casino-ja.embed.svg": 51066,
	"swf-core/assets/localized/casino-lt.embed.svg": 3007,
	"swf-core/assets/localized/casino-lv.embed.svg": 47794,
	"swf-core/assets/localized/casino-nl.embed.svg": 13403,
	"swf-core/assets/localized/casino-no.embed.svg": 27898,
	"swf-core/assets/localized/casino-pl.embed.svg": 97271,
	"swf-core/assets/localized/casino-pt-BR.embed.svg": 50516,
	"swf-core/assets/localized/casino-pt.embed.svg": 95850,
	"swf-core/assets/localized/casino-ro.embed.svg": 27797,
	"swf-core/assets/localized/casino-ru.embed.svg": 32575,
	"swf-core/assets/localized/casino-sl.embed.svg": 62515,
	"swf-core/assets/localized/casino-sv.embed.svg": 77863,
	"swf-core/assets/localized/casino-uk.embed.svg": 74036,
	"swf-core/assets/localized/casino-zh-CN.embed.svg": 24167,
	"swf-core/assets/localized/casino-zh-TW.embed.svg": 50745,
	"swf-core/assets/localized/poker-bg.embed.svg": 77638,
	"swf-core/assets/localized/poker-cs.embed.svg": 8824,
	"swf-core/assets/localized/poker-da.embed.svg": 80792,
	"swf-core/assets/localized/poker-de.embed.svg": 57160,
	"swf-core/assets/localized/poker-el.embed.svg": 57965,
	"swf-core/assets/localized/poker-en.embed.svg": 36947,
	"swf-core/assets/localized/poker-es.embed.svg": 75988,
	"swf-core/assets/localized/poker-et.embed.svg": 3409,
	"swf-core/assets/localized/poker-fi.embed.svg": 11405,
	"swf-core/assets/localized/poker-fr.embed.svg": 22460,
	"swf-core/assets/localized/poker-hr.embed.svg": 28839,
	"swf-core/assets/localized/poker-hu.embed.svg": 67364,
	"swf-core/assets/localized/poker-is.embed.svg": 16998,
	"swf-core/assets/localized/poker-it.embed.svg": 91082,
	"swf-core/assets/localized/poker-ja.embed.svg": 38999,
	"swf-core/assets/localized/poker-lt.embed.svg": 56466,
	"swf-core/assets/localized/poker-lv.embed.svg": 88759,
	"swf-core/assets/localized/poker-nl.embed.svg": 41566,
	"swf-core/assets/localized/poker-no.embed.svg": 71715,
	"swf-core/assets/localized/poker-pl.embed.svg": 88705,
	"swf-core/assets/localized/poker-pt-BR.embed.svg": 49538,
	"swf-core/assets/localized/poker-pt.embed.svg": 76909,
	"swf-core/assets/localized/poker-ro.embed.svg": 65425,
	"swf-core/assets/localized/poker-ru.embed.svg": 90282,
	"swf-core/assets/localized/poker-sl.embed.svg": 64826,
	"swf-core/assets/localized/poker-sv.embed.svg": 94919,
	"swf-core/assets/localized/poker-uk.embed.svg": 6517,
	"swf-core/assets/localized/poker-zh-CN.embed.svg": 43669,
	"swf-core/assets/localized/poker-zh-TW.embed.svg": 15207,
	"swf-core/assets/localized/sports-bg.embed.svg": 16580,
	"swf-core/assets/localized/sports-cs.embed.svg": 97895,
	"swf-core/assets/localized/sports-da.embed.svg": 10230,
	"swf-core/assets/localized/sports-de.embed.svg": 19032,
	"swf-core/assets/localized/sports-el.embed.svg": 64917,
	"swf-core/assets/localized/sports-en.embed.svg": 67664,
	"swf-core/assets/localized/sports-es.embed.svg": 76127,
	"swf-core/assets/localized/sports-et.embed.svg": 43003,
	"swf-core/assets/localized/sports-fi.embed.svg": 1782,
	"swf-core/assets/localized/sports-fr.embed.svg": 12572,
	"swf-core/assets/localized/sports-hr.embed.svg": 13800,
	"swf-core/assets/localized/sports-hu.embed.svg": 17638,
	"swf-core/assets/localized/sports-is.embed.svg": 4249,
	"swf-core/assets/localized/sports-it.embed.svg": 72434,
	"swf-core/assets/localized/sports-ja.embed.svg": 74171,
	"swf-core/assets/localized/sports-lt.embed.svg": 33416,
	"swf-core/assets/localized/sports-lv.embed.svg": 6311,
	"swf-core/assets/localized/sports-nl.embed.svg": 38168,
	"swf-core/assets/localized/sports-no.embed.svg": 54397,
	"swf-core/assets/localized/sports-pl.embed.svg": 50329,
	"swf-core/assets/localized/sports-pt-BR.embed.svg": 1260,
	"swf-core/assets/localized/sports-pt.embed.svg": 11529,
	"swf-core/assets/localized/sports-ro.embed.svg": 19483,
	"swf-core/assets/localized/sports-ru.embed.svg": 24339,
	"swf-core/assets/localized/sports-sl.embed.svg": 5419,
	"swf-core/assets/localized/sports-sv.embed.svg": 89479,
	"swf-core/assets/localized/sports-uk.embed.svg": 11765,
	"swf-core/assets/localized/sports-zh-CN.embed.svg": 18583,
	"swf-core/assets/localized/sports-zh-TW.embed.svg": 97901
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 72090;
module.exports = webpackAsyncContext;